<div class="d-flex justify-content-end text-end font-md mt-1">
  <div [translate]="'paymentIntent.summary.originalPrice'">
    Original order price
  </div>
  <div class="summary-value-col">
    {{(paymentIntent.order.multiOrder.price - paymentIntent.amount) | currencyFormat: currency}}
  </div>
</div>

<div class="d-flex justify-content-end text-end font-md mt-1">
  <div [translate]="'paymentIntent.summary.orderChange'">
    Order change
  </div>
  <div class="summary-value-col">
    +{{paymentIntent.amount | currencyFormat: currency}}
  </div>
</div>

<div class="d-flex justify-content-end text-end font-lg text-bold mt-1">
  <div [translate]="'paymentIntent.summary.updatedPrice'">
    Updated price
  </div>
  <div class="summary-value-col">
    {{paymentIntent.order.multiOrder.price | currencyFormat: currency}}
  </div>
</div>
